import { BaseModel, EntityProperty } from '@tcc-mono/shared/data-access';
import { Relation } from './relation.model';

export interface KoppelTypeSettings {
  [key: string]: number;
}

export class Stable extends BaseModel {
  id: number;
  relation_id?: number;
  relation_name?: string;
  created_at?: string;
  //current_animal count is niet current. Dit is het totaal aantal dieren dat OOIT op een transportgroep naar de slal is gegaan.
  // Dus alle animals met de stable id.
  current_animal_count?: number;
  name?: string;
  ubn?: string;
  relation_visit_name?: string;
  relation_visit_address?: string;
  relation_visit_zipcode?: string;
  relation_visit_city?: string;
  relation_visit_country?: string;
  relation_visit_phone?: string;
  address?: string;
  zipcode?: string;
  city?: string;
  country?: string;
  phone?: string;
  remarks?: string;
  updated_at?: string;
  properties?: EntityProperty[];
  weide_toeslag?: boolean;
  vitaal_kalf_participant?: boolean;
  rvo_eigenbeheer?: boolean;
  is_gtskv_loadingplace?: boolean;
  skv_capacity?: number | null;
  can_register_rvo?: boolean;
  rvo_arrivals_enabled_at?: string | null;
  koppel_type_settings?: KoppelTypeSettings;
}

export function stableRelationVisitFromRelation(
  relation: Pick<
    Relation,
    'id' | 'visit_name' | 'visit_address' | 'visit_zip' | 'visit_city' | 'visit_country' | 'visit_phone'
  >
): Pick<
  Stable,
  | 'relation_id'
  | 'relation_visit_name'
  | 'relation_visit_address'
  | 'relation_visit_zipcode'
  | 'relation_visit_city'
  | 'relation_visit_country'
  | 'relation_visit_phone'
> {
  return {
    relation_id: relation.id,
    relation_visit_name: relation.visit_name,
    relation_visit_address: relation.visit_address,
    relation_visit_zipcode: relation.visit_zip,
    relation_visit_city: relation.visit_city,
    relation_visit_country: relation.visit_country,
    relation_visit_phone: relation.visit_phone,
  };
}
